var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }